export const CONTENT_PLACEHOLDER = '-'

export const MULTI_ORDER_VALUE = 2

export const SIMPLE_ORDER_VALUE = 1

export const NO_IMAGE_BASE64 =
	'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+kAAAV4AQMAAADmGQ7gAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRF////p8QbyAAAAAF0Uk5TA9nvidwAAADDSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPAYtqYAAS7k7FoAAAAASUVORK5CYII='

export const LOOK_IMAGE_DEFAULT = '00'

export const TYPE_IMAGES_DEFAULT = ['F', 'O1', 'B']
